const handleNumericCheck = (event, type) => {
  let value = event.target.value;
  let decimalIndex = value.indexOf('.');
  let charCode = event.charCode;
  let cursorPosition = event.target.selectionStart;

  // Allow numeric characters (0-9)
  if (charCode >= 48 && charCode <= 57) {
    // For 'decimal', restrict to two decimal places
    if (type === 'decimal' && decimalIndex !== -1 && value.substring(decimalIndex + 1).length >= 2) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  // Allow the decimal point (.) for 'decimal' type if it doesn't already exist
  if (type === 'decimal' && charCode === 46 && decimalIndex === -1) {
    return true;
  }

  // Allow the minus sign (-) if the cursor is at the start of the input
  if (charCode === 45 && cursorPosition === 0) {
    return true;
  }

  // Prevent all other characters
  event.preventDefault();
  return false;
};

export default handleNumericCheck;
